import React from 'react';
import classes from './SMSPackageDetailCard.module.css';
import CommonCard from '../CommonCard';
import LabeledText from '../LabeledText';
import { formattedDatePart } from '../../../Helpers';
const SMSPackageDetailCard = ({ data }) => {
  let decideDate =
    formattedDatePart(data?.createdTimestamp) === formattedDatePart(new Date())
      ? 'Today'
      : formattedDatePart(data?.createdTimestamp);
  return (
    <CommonCard>
      <ul className={classes.wrapper}>
        <LabeledText Tag="li" label={'Package Name'} value={data?.subscriptionNote} />
        <LabeledText Tag="li" label={'SMS'} value={`${data?.assignedNoOfSMS}/${data?.period}`} />
        <LabeledText
          className={classes.cancelledOn}
          Tag="li"
          label={'Purchased On'}
          value={decideDate}
        />
        <LabeledText
          className={classes.purchasedOn}
          Tag="li"
          label={'Purchased On'}
          value={decideDate}
        />
        <LabeledText Tag="li" label={'Payment'} value={data?.paymentMethod} />
        <LabeledText Tag="li" label={'Invoice'} value={'View'} className={classes.invoiceCard} />
      </ul>
    </CommonCard>
  );
};

export default SMSPackageDetailCard;
